module.exports = __webpack_public_path__ + "assets/img/shop-defaultImg.0a03749e.png";